module.exports = __webpack_public_path__ + "static/media/taraBaseballTwo.751c6545.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taraBaseballTwo.svg
// module id = 610
// module chunks = 0